<template>
  <v-card>
    <v-form>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="mr-2">
              <v-icon color="green lighten-2" v-if="!batch[fieldData.field]">{{fieldData.iconOn}}</v-icon>
              <v-icon color="grey" v-else>{{fieldData.iconOff}}</v-icon>
            </span>
            <span class="headline">
              Update
              <!-- {{batch[fieldData.field] ? 'Unconfirm' : 'Confirm'}} -->
              <span class="grey--text subheading">- {{ fieldData.label}}</span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-textarea auto-grow label="Notes" rows="2" v-model="currentNotes"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete label="* Status" :items="statusOptions" v-model="currentStatus"></v-autocomplete>
          </v-flex>
          <v-flex xs12>Would you like to update {{ fieldData.label}} data?</v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close()" :color="primaryGrey">No</v-btn>
      <v-btn flat @click="updateBatchField()" :loading="loading" color="green darken-1">Yes</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AllocationService from '@/services/requests/allocationService'
export default {
  data() {
    return {
      currentNotes: '',
      currentStatus: '',
      statusOptions: ['NOT SET', 'CONFIRMED', 'REVIEW'],
      loading: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    updateBatchField() {
      this.loading = true
      var payload = {
        id: this.batch.id,
        field: this.fieldData.field,
        notesField: this.fieldData.notesField,
        value: this.currentStatus,
        notes: this.currentNotes
      }
      console.log(payload)
      AllocationService.updateBatchField(payload)
        .then(result => {
          this.$emit('actionComplete')
          console.log(result)
          this.$store.commit('allocationStaging/updateArrayStateById', {
            prop: 'batches',
            editedValue: result.data.result.batch
          })
          this.loading = false
          this.snack({ color: 'green', text: 'Batch was updated' })
        })
        .catch(err => {
          this.snackError()
          this.loading = false
          console.log(err)
        })
    }
  },

  props: {
    batch: Object,
    fieldData: Object,
    notes: String,
    status: String
  },
  watch: {
    notes(val) {
      this.currentNotes = val
    },
    status(val) {
      this.currentStatus = val
    }
  },
  mounted() {
    this.currentNotes = this.notes
    this.currentStatus = this.status
  }
}
</script>

<style>
</style>
